<template>
  <div class="seat-map-footer">
    <!-- Additional price paid or the selected seats -->
    <div v-if="totalAdditionalPrice !== ''" class="font-size-16px">
      Totale: <span class="bold">{{ totalAdditionalPrice }} €</span>
    </div>

    <!-- Flight button controls -->
    <div class="seat-map-footer-actions">
      <b-button
        v-if="isPreviousActionVisible"
        class="font-weight-bold d-xl-flex d-lg-flex d-md-flex d-md-none d-sm-none d-none align-items-center justify-content-center"
        variant="outline-tertiary"
        role="button"
        :disabled="isPreviousActionDisabled"
        @click="() => previousSegmentAction()"
      >
        Volo precedente
      </b-button>
      <span id="seat-map-next-action" class="d-inline-block">
        <b-button
          class="font-weight-bold d-flex align-items-center justify-content-center"
          variant="tertiary"
          role="button"
          :disabled="isNextSegmentActionDisabled"
          @click="() => handleNextSegmentAction()"
        >
          <span>
            {{ nextSegmentActionLabel }}
          </span>
        </b-button>
        <b-popover
          v-if="mustSelectSeats && isNextSegmentActionDisabled"
          target="seat-map-next-action"
          variant="primary"
          triggers="hover"
          placement="top"
        >
          Seleziona tutti i posti di ogni passeggero prima di continuare.
        </b-popover>
      </span>
    </div>
  </div>
</template>

<script>
import { formatPrice } from '../../../utilities';
import { getSeatPrice } from '../../../utilities/seat-map';

export default {
  name: 'seat-map-footer',
  props: {
    mustSelectSeats: {
      type: Boolean,
      default: false,
    },
    isPreviousActionVisible: Boolean,
    isPreviousActionDisabled: Boolean,
    previousSegmentAction: Function,

    nextSegmentActionLabel: String,
    isNextSegmentActionDisabled: Boolean,
    handleNextSegmentAction: Function,

    parsedSelections: Object,
  },
  methods: {
    getSeatPrice,
    formatPrice,
  },
  computed: {
    flight_offer() {
      return this.$store.state.liveflight.flight_offer;
    },
    totalAdditionalPrice() {
      const totalAdditionalPrice = Object.entries(this.parsedSelections).reduce(
        (total, segment) => {
          const segmentSelectedSeats = segment[1];
          return (
            total +
            Object.entries(segmentSelectedSeats).reduce(
              (segmentTotal, passengerSeat) =>
                segmentTotal + this.getSeatPrice(passengerSeat[1], passengerSeat[0]),
              0
            )
          );
        },
        0
      );
      if (totalAdditionalPrice <= 0) {
        return '';
      }
      return this.formatPrice(totalAdditionalPrice);
    },
  },
};
</script>

<style lang="scss">
.seat-map-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  div:last-of-type {
    margin-left: auto;
  }
}
.seat-map-footer-actions {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
</style>
